import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import textContrastClass from 'flarum/common/helpers/textContrastClass';
import classList from 'flarum/common/utils/classList';
import ItemList from 'flarum/common/utils/ItemList';
export default class PrivateHero extends Component {
  view() {
    const color = this.heroColor();
    return m("header", {
      className: classList('Hero', 'PrivateHero', {
        'PrivateHero--colored': color,
        [textContrastClass(color)]: color
      }),
      style: color ? {
        '--hero-bg': color
      } : undefined
    }, m("div", {
      className: "container"
    }, this.viewItems().toArray()));
  }
  viewItems() {
    const items = new ItemList();
    items.add('content', m("div", {
      className: "containerNarrow"
    }, this.contentItems().toArray()), 80);
    return items;
  }
  contentItems() {
    const items = new ItemList();
    items.add('private-discussions-title', m("h1", {
      className: "Hero-title"
    }, m(Icon, {
      name: this.heroIcon()
    }), " ", app.translator.trans('fof-byobu.forum.hero.title')), 100);

    // Don't think a subtitle is necessary, but can be added if needed.
    //items.add('private-discussions-subtitle', <div className="Hero-subtitle">{app.translator.trans('fof-byobu.forum.hero.subtitle')}</div>, 90);

    return items;
  }
  heroColor() {
    // Example return a color string to display a colored hero
    //return app.forum.attribute<string>('themeSecondaryColor');
    return null;
  }
  heroIcon() {
    var _app$forum$data$attri;
    return (_app$forum$data$attri = app.forum.data.attributes) == null ? void 0 : _app$forum$data$attri['byobu.icon-badge'];
  }
}
flarum.reg.add('fof-byobu', 'forum/components/PrivateHero', PrivateHero);